import styled from 'styled-components'

import { Flex } from '@inter/inter-ui/components/Flex'

export const Container = styled(Flex)`
  text-align: center;
  max-width: 312px;
  margin: 0 auto;
`
